import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

export default function () {
	// Based on w3 recommendations: https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-1/tabs.html
	const tabs = document.querySelectorAll('.js-tabs');
	const keys = {
		up: 38,
		down: 40,
	};

	const activateTab = (tab) => {
		//deactivate all buttons
		tab.parentElement.querySelectorAll('[role="tab"]').forEach((tab) => {
			tab.setAttribute('tabindex', '-1');
			tab.setAttribute('aria-selected', 'false');
		});
		// Remove tabindex attribute
		tab.removeAttribute('tabindex');
		// Set the tab as selected
		tab.setAttribute('aria-selected', 'true');
		// Get the element from aria-controls (which is an ID)
		const panel = document.getElementById(
			tab.getAttribute('aria-controls')
		);
		// Hide all other panels
		panel.parentElement
			.querySelectorAll('[role="tabpanel"]')
			.forEach((tabpanel) => {
				tabpanel.classList.add('is-hidden');
				tabpanel.setAttribute('aria-hidden', 'true');
			});
		// Remove is-hidden class from panel to make it visible
		panel.classList.remove('is-hidden');
		panel.setAttribute('aria-hidden', 'false');
		tab.focus();
	};

	const clickEventListener = (event) => {
		activateTab(event.target);
	};

	const keydownEventListener = (event) => {
		const key = event.keyCode;

		if (key === keys.up || key === keys.down) {
			// This will prevent scrolling when using keys
			event.preventDefault();
		}
	};

	const keyupEventListener = (event) => {
		const key = event.keyCode;

		if (key === keys.up) {
			event.preventDefault();
			if (event.target.previousElementSibling) {
				activateTab(event.target.previousElementSibling);
			} else {
				activateTab(event.target.parentElement.lastElementChild);
			}
		}

		if (key === keys.down) {
			event.preventDefault();
			if (event.target.nextElementSibling) {
				activateTab(event.target.nextElementSibling);
			} else {
				activateTab(event.target.parentElement.firstElementChild);
			}
		}
	};

	if (tabs.length) {
		tabs.forEach((parent) => {
			parent.querySelectorAll('[role="tab"]').forEach((button, index) => {
				button.addEventListener('click', clickEventListener);
				button.addEventListener('keydown', keydownEventListener);
				button.addEventListener('keyup', keyupEventListener);
				if (index !== 0) {
					button.setAttribute('tabindex', '-1');
				}
			});

			// Tab Panels
			parent.querySelectorAll('.tabs__tab').forEach((tab, index) => {
				tab.setAttribute('role', 'tabpanel');
				tab.setAttribute('tabindex', '0');
				if (index !== 0) {
					tab.classList.add('is-hidden');
					tab.setAttribute('aria-hidden', 'true');
				}
			});
		});
	}

	// Slideshows

	const tabCarousels = document.querySelectorAll('.js-tab-carousel');

	tabCarousels.forEach((carousel) => {
		if (carousel.querySelectorAll('.swiper-slide').length > 1) {
			const config = {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
				},
			};

			new Swiper(carousel, config);
		}
	});
}
